import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '../views/layout/Layout'

/** 通用路由表 */
export const constantRouterMap = [
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true
  },
  {
    path: '/h5/winTheCustomer',
    component: () => import('@/views/winTheCustomer/index'),
    hidden: true
  },
  {
    path: '/h5/eventRegistration',
    component: () => import('@/views/eventRegistration/index'),
    hidden: true
  },
  {
    path: '/h5/eventRegistration/close',
    component: () => import('@/views/eventRegistration/close.vue'),
    hidden: true
  },
   {
    path: '/h5/eventRegistration/success',

    component: () => import('@/views/eventRegistration/success.vue'),
    hidden: true
  },
  {
    path: '/privacy',
    component: () => import('@/views/privacy/index'),
    hidden: true
  },
  { path: '/404', component: () => import('@/views/404'), hidden: true }
];

//厂商路由表
export const factoryRoutes = [
  {
    path: '',
    component: Layout,
    redirect: '/home',
    meta: {
      title: '首页',
      icon: 'homecur'
    },
    children: [
      {
        path: 'home',
        name: 'home',
        hidden: false,
        component: () => import('@/views/home/index'),
        meta: {
          title: '首页',
          icon: 'homecur'
        }
      },
      {
        path: 'homeLead',
        name: 'homeLead',
        hidden: true,
        component: () => import('@/views/home/lead'),
        meta: {
          title: '线索待分配',
          icon: 'homecur'
        }
      },
      {
        path: 'homeOverdue',
        name: 'homeOverdue',
        hidden: true,
        component: () => import('@/views/home/overdue'),
        meta: {
          title: '逾期未跟进',
          icon: 'homecur'
        }
      },
    ]
  },
  {
    path: '/basic',
    component: Layout,
    meta: {
      title: '基础设置',
      icon: 'system'
    },
    hidden: false,
    children: [
      {
        path: 'car',
        name: 'car',
        hidden: false,
        component: () => import('@/views/basic/car'),
        meta: {
          title: '车型管理',
        },
      },
      {
        path: 'source',
        name: 'source',
        hidden: false,
        component: () => import('@/views/basic/source'),
        meta: {
          title: '客户来源管理',
        },
      },
      {
        path: 'reason',
        name: 'reason',
        hidden: false,
        component: () => import('@/views/basic/reason'),
        meta: {
          title: '战败原因管理',
        },
      },
      {
        path: 'invalid',
        name: 'invalid',
        hidden: false,
        component: () => import('@/views/basic/invalid'),
        meta: {
          title: '无效原因管理',
        },
      },
      {
        path: 'intention',
        name: 'intention',
        hidden: false,
        component: () => import('@/views/basic/intention'),
        meta: {
          title: '意向等级管理',
        },
      },
      {
        path: 'event',
        name: 'event',
        hidden: false,
        component: () => import('@/views/basic/event'),
        meta: {
          title: '活动管理',
        },

      },
      {
        path: 'leadList',
        name: 'leadList',
        hidden: true,
        component: () => import('@/views/basic/leadList'),
        meta: {
          title: '活动留资列表',
        },
      }
    ]
  },
  {
    path: '',
    component: Layout,
    meta: {
      title: '人员管理',
      icon: 'delaruser'
    },
    hidden: false,
    children: [
      {
        path: 'factory',
        name: 'factory',
        hidden: false,
        component: () => import('@/views/person/factory'),
        meta: {
          title: '厂商人员管理',
        },
      },
      {
        path: 'dealer',
        name: 'dealer',
        hidden: false,
        component: () => import('@/views/person/dealer'),
        meta: {
          title: '经销商人员管理',
        },
      }
    ]
  },
  {
    path: '/dealerMan',
    component: Layout,
    hidden: false,
    meta: {
      title: '经销商管理',
      icon: 'system'
    },
    children: [
      {
        path: 'dealerMan',
        name: 'dealerMan',
        hidden: false,
        component: () => import('@/views/dealer/index'),
        meta: {
          title: '经销商管理',
        },
      },
      {
        path: 'group',
        name: 'group',
        hidden: false,
        component: () => import('@/views/dealer/group'),
        meta: {
          title: '分店/小组管理',
        },
      }
    ]
  },
  {
    path: '/report',
    component: Layout,
    meta: {
      title: '数据报表',
      icon: 'kpi'
    },
    hidden: false,
    children: [
      {
        path: 'dealer',
        name: 'dealer',
        hidden: false,
        component: () => import('@/views/report/dealer'),
        meta: {
          title: '经销商报表',
        },
      },
      {
        path: 'source',
        name: 'source',
        hidden: false,
        component: () => import('@/views/report/source'),
        meta: {
          title: '来源报表',
        },
      },
      {
        path: 'serail',
        name: 'serail',
        hidden: false,
        component: () => import('@/views/report/serail'),
        meta: {
          title: '车系报表',
        },
      }
    ]
  },
  {
    path: '/detailed',
    component: Layout,
    meta: {
      title: '数据明细',
      icon: 'courseware'
    },
    hidden: false,
    children: [
      {
        path: 'custom',
        name: 'custom',
        hidden: false,
        component: () => import('@/views/detailed/custom'),
        meta: {
          title: '客户明细',
        },
      },
      {
        path: 'follow',
        name: 'follow',
        hidden: false,
        component: () => import('@/views/detailed/follow'),
        meta: {
          title: '跟进明细'
        },
      }
    ]
  },
  {
    path: '/customman',
    component: Layout,
    meta: {
      title: '客户管理',
      icon: 'upbeat'
    },
    hidden: false,
    children: [
      {
        path: 'lead',
        name: 'lead',
        hidden: false,
        component: () => import('@/views/customman/lead'),
        meta: {
          title: '线索客户',
          // icon: 'upbeat'
        },
      },
      {
        path: 'intention',
        name: 'intention',
        hidden: false,
        component: () => import('@/views/customman/intention'),
        meta: {
          title: '意向客户',
          // icon: 'upbeat'
        },
      },
      {
        path: 'order',
        name: 'order',
        hidden: false,
        component: () => import('@/views/customman/order'),
        meta: {
          title: '订车客户',
          // icon: 'upbeat'
        },
      },
      {
        path: 'deal',
        name: 'deal',
        hidden: false,
        component: () => import('@/views/customman/deal'),
        meta: {
          title: '交车客户',
          // icon: 'upbeat'
        },
      },
      {
        path: 'defeat',
        name: 'defeat',
        hidden: false,
        component: () => import('@/views/customman/defeat'),
        meta: {
          title: '战败客户',
          // icon: 'upbeat'
        },
      },
      {
        path: 'invalid',
        name: 'invalid',
        hidden: false,
        component: () => import('@/views/customman/invalid'),
        meta: {
          title: '无效客户',
          // icon: 'upbeat'
        },
      },
    ]
  },
  {
    path: '/target',
    component: Layout,
    meta: {
      title: '业绩目标管理',
      icon: 'total-week'
    },
    hidden: false,
    children: []
  },
  {
    path: '/detail',
    component: Layout,
    meta: {
      title: '客户信息',
      icon: 'delar'
    },
    hidden: true,
    children: [
      {
        path: 'detail',
        name: 'detail',
        hidden: false,
        component: () => import('@/views/common/detail'),
        meta: {
          title: '客户信息',
        },
      },
      {
        path: 'command',
        name: 'command',
        hidden: false,
        component: () => import('@/views/common/command'),
        meta: {
          title: '管辖店数',
        },
      }
    ]
  },
  {
    path: '/record',
    component: Layout,
    meta: {
      title: '操作记录',
      icon: 'eye'
    },
    hidden: false,
    children: [
      {
        path: 'rallocation',
        name: 'rallocation',
        hidden: false,
        component: () => import('@/views/record/allocation'),
        meta: {
          title: '分配记录'
        },
      },
      {
        path: 'csdetail',
        name: 'csdetail',
        hidden: true,
        component: () => import('@/views/record/csdetail'),
        meta: {
          title: '分配明细'
        },
      },
      {
        path: 'rupload',
        name: 'rupload',
        hidden: false,
        component: () => import('@/views/record/upload'),
        meta: {
          title: '上传记录'
        },
      },
      {
        path: 'transfer',
        name: 'transfer',
        hidden: false,
        component: () => import('@/views/record/transfer'),
        meta: {
          title: '异地流转记录'
        },
      }
    ]
  },
  {
    path: '/weixin',
    component: Layout,
    meta: {
      title: '微信客户',
      icon: 'wework'
    },
    hidden: false,
    children: [
      {
        path: 'wxcust',
        name: 'wxcust',
        hidden: false,
        component: () => import('@/views/weixin/weixin'),
        meta: {
          title: '微信客户',
          icon: 'wework'
        },
      }
    ]
  },
]
/** 经销商路由表 */

export const dealerRoutes = [
  {
    path: '/basic',
    component: Layout,
    meta: {
      title: '基础设置',
      icon: 'system'
    },
    hidden: false,
    children: [
      {
        path: 'car',
        name: 'car',
        hidden: false,
        component: () => import('@/views/basic/car'),
        meta: {
          title: '车型管理',
        },
      },
      {
        path: 'source',
        name: 'source',
        hidden: false,
        component: () => import('@/views/basic/source'),
        meta: {
          title: '客户来源管理',
        },
      },
      {
        path: 'reason',
        name: 'reason',
        hidden: false,
        component: () => import('@/views/basic/reason'),
        meta: {
          title: '战败原因管理',
        },
      },
      {
        path: 'invalid',
        name: 'invalid',
        hidden: false,
        component: () => import('@/views/basic/invalid'),
        meta: {
          title: '无效原因管理',
        },
      },
      {
        path: 'intention',
        name: 'intention',
        hidden: false,
        component: () => import('@/views/basic/intention'),
        meta: {
          title: '意向等级管理',
        },
      }
    ]
  },
  {
    path: '',
    component: Layout,
    meta: {
      title: '数据报表',
      icon: 'kpi'
    },
    hidden: false,
    children: [
      {
        path: 'source',
        name: 'source',
        hidden: false,
        component: () => import('@/views/report/source'),
        meta: {
          title: '来源报表',
        },
      },
      {
        path: 'groupexcel',
        name: 'groupxcel',
        hidden: false,
        component: () => import('@/views/report/group'),
        meta: {
          title: '分店/小组报表',
        },
      },
      {
        path: 'sale',
        name: 'sale',
        hidden: false,
        component: () => import('@/views/report/sale'),
        meta: {
          title: '销售顾问报表',
        },
      },
      {
        path: 'serail',
        name: 'serail',
        hidden: false,
        component: () => import('@/views/report/serail'),
        meta: {
          title: '车系报表',
        },
      }
    ]
  },
  {
    path: '/detailed',
    component: Layout,
    meta: {
      title: '数据明细',
      icon: 'courseware'
    },
    hidden: false,
    children: [
      {
        path: 'custom',
        name: 'custom',
        hidden: false,
        component: () => import('@/views/detailed/custom'),
        meta: {
          title: '客户明细',
        },
      },
      {
        path: 'follow',
        name: 'follow',
        hidden: false,
        component: () => import('@/views/detailed/follow'),
        meta: {
          title: '跟进明细',
        },
      },
    ]
  },
  {
    path: '/customman',
    component: Layout,
    meta: {
      title: '客户管理',
      icon: 'upbeat'
    },
    hidden: false,
    children: [
      {
        path: 'lead',
        name: 'lead',
        hidden: false,
        component: () => import('@/views/customman/lead'),
        meta: {
          title: '线索客户',
        },
      },
      {
        path: 'intention',
        name: 'intention',
        hidden: false,
        component: () => import('@/views/customman/intention'),
        meta: {
          title: '意向客户',
        },
      },
      {
        path: 'order',
        name: 'order',
        hidden: false,
        component: () => import('@/views/customman/order'),
        meta: {
          title: '订车客户',
        },
      },
      {
        path: 'deal',
        name: 'deal',
        hidden: false,
        component: () => import('@/views/customman/deal'),
        meta: {
          title: '交车客户',
        },
      },
      {
        path: 'defeat',
        name: 'defeat',
        hidden: false,
        component: () => import('@/views/customman/defeat'),
        meta: {
          title: '战败客户',
        },
      },
      {
        path: 'invalid',
        name: 'invalid',
        hidden: false,
        component: () => import('@/views/customman/invalid'),
        meta: {
          title: '无效客户',
        },
      },
    ]
  },
  {
    path: '/detail',
    component: Layout,
    meta: {
      title: '客户信息',
      icon: 'delar'
    },
    hidden: true,
    children: [
      {
        path: 'detail',
        name: 'detail',
        hidden: false,
        component: () => import('@/views/common/detail'),
        meta: {
          title: '客户信息',
        },
      },
      {
        path: 'process',
        name: 'process',
        hidden: false,
        component: () => import('@/views/common/process'),
        meta: {
          title: '线索导入',
        },
      }
    ]
  },
  {
    path: '/examine',
    component: Layout,
    meta: {
      title: '待处理',
      icon: 'courseware'
    },
    hidden: false,
    children: [
      {
        path: 'defeat',
        name: 'defeat',
        hidden: false,
        component: () => import('@/views/examine/defeat'),
        meta: {
          title: '战败审批',
        },
      },
      {
        path: 'invalid',
        name: 'invalid',
        hidden: false,
        component: () => import('@/views/examine/invalid'),
        meta: {
          title: '无效审批',
        },
      },
      {
        path: 'task',
        name: 'task',
        hidden: false,
        component: () => import('@/views/examine/task'),
        meta: {
          title: '任务审批',
        },
      },
      {
        path: 'transfer',
        name: 'transfer',
        hidden: false,
        component: () => import('@/views/examine/transfer'),
        meta: {
          title: '异地流转审批',
        },
      },
      {
        path: 'callocation',
        name: 'callocation',
        hidden: false,
        component: () => import('@/views/examine/callocation'),
        meta: {
          title: '客户待分配',
        },
      },
      {
        path: 'allocation',
        name: 'allocation',
        hidden: false,
        component: () => import('@/views/examine/allocation'),
        meta: {
          title: '线索待分配',
        },
      },
      {
        path: 'overdue',
        name: 'overdue',
        hidden: false,
        component: () => import('@/views/examine/overdue'),
        meta: {
          title: '逾期未跟进',
        },
      },
    ]

  },
  {
    path: '/group',
    component: Layout,
    meta: {
      title: '经销商管理',
      icon: 'delar'
    },
    hidden: false,
    children: [
      {
        path: 'group',
        name: 'group',
        hidden: false,
        component: () => import('@/views/group/index'),
        meta: {
          title: '分店/小组管理',
        },
      },
      {
        path: 'person',
        name: 'person',
        hidden: false,
        component: () => import('@/views/group/person'),
        meta: {
          title: '人员管理',
        },
      }
    ]
  },
  {
    path: '/stock',
    component: Layout,
    meta: {
      title: '库存管理',
      icon: 'nested'
    },
    hidden: false,
    children: [
      {
        path: 'stock',
        name: 'stock',
        hidden: false,
        component: () => import('@/views/stock/index'),
        meta: {
          title: '库存管理',
          icon: 'nested'
        },
      }
    ]
  },
  {
    path: '/record',
    component: Layout,
    meta: {
      title: '操作记录',
      icon: 'eye'
    },
    hidden: false,
    children: [
      {
        path: 'rallocation',
        name: 'rallocation',
        hidden: false,
        component: () => import('@/views/record/allocation'),
        meta: {
          title: '分配记录'
        },
      },
      {
        path: 'rupload',
        name: 'rupload',
        hidden: false,
        component: () => import('@/views/record/upload'),
        meta: {
          title: '上传记录'
        },
      },
    ]
  },
  {
    path: '/weixin',
    component: Layout,
    meta: {
      title: '微信客户',
      icon: 'wework'
    },
    hidden: false,
    children: [
      {
        path: 'wxcust',
        name: 'wxcust',
        hidden: false,
        component: () => import('@/views/weixin/weixin'),
        meta: {
          title: '微信客户',
          icon: 'wework'
        },
      }
    ]
  },
  {
    path: '/target',
    component: Layout,
    meta: {
      title: '业绩目标管理',
      icon: 'total-week'
    },
    hidden: false,
    children: [
      {
        path: 'targetPerson',
        name: 'targetPerson',
        hidden: false,
        component: () => import('@/views/target/person'),
        meta: {
          title: '业绩目标',
          icon: 'total-week'
        },
      }
    ]
  },
  // 上传文件的路由地址
  {
    path: '/import',
    component: Layout,
    hidden: true, // 隐藏在左侧菜单中
    children: [{
      path: '',
      component: () => import('@/views/import')
    }]
  },
]
//经销商-销售顾问
export const counselorRouters = [
  {
    path: '',
    component: Layout,
    meta: {
      title: '数据报表',
      icon: 'kpi'
    },
    hidden: false,
    children: [
      {
        path: 'source',
        name: 'source',
        hidden: false,
        component: () => import('@/views/report/source'),
        meta: {
          title: '来源报表',
        },
      },
      {
        path: 'group',
        name: 'group',
        hidden: false,
        component: () => import('@/views/report/group'),
        meta: {
          title: '分店/小组报表',
        },
      },
      {
        path: 'sale',
        name: 'sale',
        hidden: false,
        component: () => import('@/views/report/sale'),
        meta: {
          title: '销售顾问报表',
        },
      },
      {
        path: 'serail',
        name: 'serail',
        hidden: false,
        component: () => import('@/views/report/serail'),
        meta: {
          title: '车系报表',
        },
      }
    ]
  },
  {
    path: '/detailed',
    component: Layout,
    meta: {
      title: '数据明细',
      icon: 'courseware'
    },
    hidden: false,
    children: [
      {
        path: 'custom',
        name: 'custom',
        hidden: false,
        component: () => import('@/views/detailed/custom'),
        meta: {
          title: '客户明细',
        },
      },
      {
        path: 'follow',
        name: 'follow',
        hidden: false,
        component: () => import('@/views/detailed/follow'),
        meta: {
          title: '跟进明细',
        },
      }
    ]
  },
  {
    path: '/customman',
    component: Layout,
    meta: {
      title: '客户管理',
      icon: 'upbeat'
    },
    hidden: false,
    children: [
      {
        path: 'lead',
        name: 'lead',
        hidden: false,
        component: () => import('@/views/customman/lead'),
        meta: {
          title: '线索客户',
        },
      },
      {
        path: 'intention',
        name: 'intention',
        hidden: false,
        component: () => import('@/views/customman/intention'),
        meta: {
          title: '意向客户',
        },
      },
      {
        path: 'order',
        name: 'order',
        hidden: false,
        component: () => import('@/views/customman/order'),
        meta: {
          title: '订车客户',
        },
      },
      {
        path: 'deal',
        name: 'deal',
        hidden: false,
        component: () => import('@/views/customman/deal'),
        meta: {
          title: '交车客户',
        },
      },
      {
        path: 'defeat',
        name: 'defeat',
        hidden: false,
        component: () => import('@/views/customman/defeat'),
        meta: {
          title: '战败客户',
        },
      },
      {
        path: 'invalid',
        name: 'invalid',
        hidden: false,
        component: () => import('@/views/customman/invalid'),
        meta: {
          title: '无效客户',
        },
      },
    ]
  },
  {
    path: '/detail',
    component: Layout,
    meta: {
      title: '客户信息',
      icon: 'delar'
    },
    hidden: true,
    children: [
      {
        path: 'detail',
        name: 'detail',
        hidden: false,
        component: () => import('@/views/common/detail'),
        meta: {
          title: '客户信息',
        },
      }
    ]
  },
  // 上传文件的路由地址
  {
    path: '/import',
    component: Layout,
    hidden: true, // 隐藏在左侧菜单中
    children: [{
      path: '',
      component: () => import('@/views/import')
    }]
  }
]
// 经销商 不是管理员权限
export const dealerRoutes2 = [
  {
    path: '/basic',
    component: Layout,
    meta: {
      title: '基础设置',
      icon: 'system'
    },
    hidden: false,
    children: [
      {
        path: 'car',
        name: 'car',
        hidden: false,
        component: () => import('@/views/basic/car'),
        meta: {
          title: '车型管理',
        },
      },
      {
        path: 'source',
        name: 'source',
        hidden: false,
        component: () => import('@/views/basic/source'),
        meta: {
          title: '客户来源管理',
        },
      },
      {
        path: 'reason',
        name: 'reason',
        hidden: false,
        component: () => import('@/views/basic/reason'),
        meta: {
          title: '战败原因管理',
        },
      },
      {
        path: 'invalid',
        name: 'invalid',
        hidden: false,
        component: () => import('@/views/basic/invalid'),
        meta: {
          title: '无效原因管理',
        },
      },
      {
        path: 'intention',
        name: 'intention',
        hidden: false,
        component: () => import('@/views/basic/intention'),
        meta: {
          title: '意向等级管理',
        },
      },
    ]
  },
  {
    path: '',
    component: Layout,
    meta: {
      title: '数据报表',
      icon: 'kpi'
    },
    hidden: false,
    children: [
      {
        path: 'source',
        name: 'source',
        hidden: false,
        component: () => import('@/views/report/source'),
        meta: {
          title: '来源报表',
        },
      },
      {
        path: 'group',
        name: 'group',
        hidden: false,
        component: () => import('@/views/report/group'),
        meta: {
          title: '分店/小组报表',
        },
      },
      {
        path: 'sale',
        name: 'sale',
        hidden: false,
        component: () => import('@/views/report/sale'),
        meta: {
          title: '销售顾问报表',
        },
      },
      {
        path: 'serail',
        name: 'serail',
        hidden: false,
        component: () => import('@/views/report/serail'),
        meta: {
          title: '车系报表',
        },
      }
    ]
  },
  {
    path: '/detailed',
    component: Layout,
    meta: {
      title: '数据明细',
      icon: 'courseware'
    },
    hidden: false,
    children: [
      {
        path: 'custom',
        name: 'custom',
        hidden: false,
        component: () => import('@/views/detailed/custom'),
        meta: {
          title: '客户明细',
        },
      },
      {
        path: 'follow',
        name: 'follow',
        hidden: false,
        component: () => import('@/views/detailed/follow'),
        meta: {
          title: '跟进明细',
        },
      }
    ]
  },
  {
    path: '/customman',
    component: Layout,
    meta: {
      title: '客户管理',
      icon: 'upbeat'
    },
    hidden: false,
    children: [
      {
        path: 'lead',
        name: 'lead',
        hidden: false,
        component: () => import('@/views/customman/lead'),
        meta: {
          title: '线索客户',
        },
      },
      {
        path: 'intention',
        name: 'intention',
        hidden: false,
        component: () => import('@/views/customman/intention'),
        meta: {
          title: '意向客户',
        },
      },
      {
        path: 'order',
        name: 'order',
        hidden: false,
        component: () => import('@/views/customman/order'),
        meta: {
          title: '订车客户',
        },
      },
      {
        path: 'deal',
        name: 'deal',
        hidden: false,
        component: () => import('@/views/customman/deal'),
        meta: {
          title: '交车客户',
        },
      },
      {
        path: 'defeat',
        name: 'defeat',
        hidden: false,
        component: () => import('@/views/customman/defeat'),
        meta: {
          title: '战败客户',
        },
      },
      {
        path: 'invalid',
        name: 'invalid',
        hidden: false,
        component: () => import('@/views/customman/invalid'),
        meta: {
          title: '无效客户',
        },
      },
    ]
  },
  {
    path: '/detail',
    component: Layout,
    meta: {
      title: '客户信息',
      icon: 'delar'
    },
    hidden: true,
    children: [
      {
        path: 'detail',
        name: 'detail',
        hidden: false,
        component: () => import('@/views/common/detail'),
        meta: {
          title: '客户信息',
        },
      }
    ]
  },
  {
    path: '/examine',
    component: Layout,
    meta: {
      title: '待处理',
      icon: 'courseware'
    },
    hidden: false,
    children: [
      {
        path: 'defeat',
        name: 'defeat',
        hidden: false,
        component: () => import('@/views/examine/defeat'),
        meta: {
          title: '战败审批',
        },
      },
      {
        path: 'invalid',
        name: 'invalid',
        hidden: false,
        component: () => import('@/views/examine/invalid'),
        meta: {
          title: '无效审批',
        },
      },
      {
        path: 'task',
        name: 'task',
        hidden: false,
        component: () => import('@/views/examine/task'),
        meta: {
          title: '任务审批',
        },
      },
      {
        path: 'callocation',
        name: 'callocation',
        hidden: false,
        component: () => import('@/views/examine/callocation'),
        meta: {
          title: '客户待分配',
        },
      },
      {
        path: 'allocation',
        name: 'allocation',
        hidden: false,
        component: () => import('@/views/examine/allocation'),
        meta: {
          title: '线索待分配',
        },
      },
      {
        path: 'overdue',
        name: 'overdue',
        hidden: false,
        component: () => import('@/views/examine/overdue'),
        meta: {
          title: '逾期未跟进',
        },
      },

    ]

  },
  {
    path: '/target',
    component: Layout,
    meta: {
      title: '业绩目标管理',
      icon: 'total-week'
    },
    hidden: false,
    children: [
      {
        path: 'targetPerson',
        name: 'targetPerson',
        hidden: false,
        component: () => import('@/views/target/person'),
        meta: {
          title: '业绩目标',
          icon: 'total-week'
        },
      }
    ]
  },
  // 上传文件的路由地址
  {
    path: '/import',
    component: Layout,
    hidden: true, // 隐藏在左侧菜单中
    children: [{
      path: '',
      component: () => import('@/views/import')
    }]
  }
]
// 经销商 组长权限
export const dealerRoutes3 = [
  {
    path: '',
    component: Layout,
    meta: {
      title: '数据报表',
      icon: 'kpi'
    },
    hidden: false,
    children: [
      {
        path: 'source',
        name: 'source',
        hidden: false,
        component: () => import('@/views/report/source'),
        meta: {
          title: '来源报表'
        },
      },
      {
        path: 'group',
        name: 'group',
        hidden: false,
        component: () => import('@/views/report/group'),
        meta: {
          title: '分店/小组报表'
        },
      },
      {
        path: 'sale',
        name: 'sale',
        hidden: false,
        component: () => import('@/views/report/sale'),
        meta: {
          title: '销售顾问报表'
        },
      },
      {
        path: 'serail',
        name: 'serail',
        hidden: false,
        component: () => import('@/views/report/serail'),
        meta: {
          title: '车系报表'
        },
      }
    ]
  },
  {
    path: '/detailed',
    component: Layout,
    meta: {
      title: '数据明细',
      icon: 'courseware'
    },
    hidden: false,
    children: [
      {
        path: 'custom',
        name: 'custom',
        hidden: false,
        component: () => import('@/views/detailed/custom'),
        meta: {
          title: '客户明细',
          // icon: 'courseware'
        },
      },
      {
        path: 'follow',
        name: 'follow',
        hidden: false,
        component: () => import('@/views/detailed/follow'),
        meta: {
          title: '跟进明细',
          // icon: 'courseware'
        },
      }
    ]
  },
  {
    path: '/customman',
    component: Layout,
    meta: {
      title: '客户管理',
      icon: 'upbeat'
    },
    hidden: false,
    children: [
      {
        path: 'lead',
        name: 'lead',
        hidden: false,
        component: () => import('@/views/customman/lead'),
        meta: {
          title: '线索客户',
          // icon: 'upbeat'
        },
      },
      {
        path: 'intention',
        name: 'intention',
        hidden: false,
        component: () => import('@/views/customman/intention'),
        meta: {
          title: '意向客户',
          // icon: 'upbeat'
        },
      },
      {
        path: 'order',
        name: 'order',
        hidden: false,
        component: () => import('@/views/customman/order'),
        meta: {
          title: '订车客户',
          // icon: 'upbeat'
        },
      },
      {
        path: 'deal',
        name: 'deal',
        hidden: false,
        component: () => import('@/views/customman/deal'),
        meta: {
          title: '交车客户',
          // icon: 'upbeat'
        },
      },
      {
        path: 'defeat',
        name: 'defeat',
        hidden: false,
        component: () => import('@/views/customman/defeat'),
        meta: {
          title: '战败客户',
          // icon: 'upbeat'
        },
      },
      {
        path: 'invalid',
        name: 'invalid',
        hidden: false,
        component: () => import('@/views/customman/invalid'),
        meta: {
          title: '无效客户',
          // icon: 'upbeat'
        },
      },
    ]
  },
  {
    path: '/detail',
    component: Layout,
    meta: {
      title: '客户信息',
      icon: 'delar'
    },
    hidden: true,
    children: [
      {
        path: 'detail',
        name: 'detail',
        hidden: false,
        component: () => import('@/views/common/detail'),
        meta: {
          title: '客户信息',
          // icon: 'delar'
        },
      }
    ]
  },
  {
    path: '/examine',
    component: Layout,
    meta: {
      title: '待处理',
      icon: 'courseware'
    },
    hidden: false,
    children: [
      {
        path: 'defeat',
        name: 'defeat',
        hidden: false,
        component: () => import('@/views/examine/defeat'),
        meta: {
          title: '战败审批',
          // icon: 'courseware'
        },
      },
      {
        path: 'invalid',
        name: 'invalid',
        hidden: false,
        component: () => import('@/views/examine/invalid'),
        meta: {
          title: '无效审批',
          // icon: 'courseware'
        },
      },
      {
        path: 'task',
        name: 'task',
        hidden: false,
        component: () => import('@/views/examine/task'),
        meta: {
          title: '任务审批',
          // icon: 'courseware'
        },
      },
      {
        path: 'overdue',
        name: 'overdue',
        hidden: false,
        component: () => import('@/views/examine/overdue'),
        meta: {
          title: '逾期未跟进',
        },
      },
    ]

  },
  // 上传文件的路由地址
  {
    path: '/import',
    component: Layout,
    hidden: true, // 隐藏在左侧菜单中
    children: [{
      path: '',
      component: () => import('@/views/import')
    }]
  }
]
// 经销商 组长 管理员 权限
export const dealerRoutes4 = [
  {
    path: '',
    component: Layout,
    meta: {
      title: '数据报表',
      icon: 'kpi'
    },
    hidden: false,
    children: [
      {
        path: 'source',
        name: 'source',
        hidden: false,
        component: () => import('@/views/report/source'),
        meta: {
          title: '来源报表'
        },
      },
      {
        path: 'group',
        name: 'group',
        hidden: false,
        component: () => import('@/views/report/group'),
        meta: {
          title: '分店/小组报表'
        },
      },
      {
        path: 'sale',
        name: 'sale',
        hidden: false,
        component: () => import('@/views/report/sale'),
        meta: {
          title: '销售顾问报表'
        },
      },
      {
        path: 'serail',
        name: 'serail',
        hidden: false,
        component: () => import('@/views/report/serail'),
        meta: {
          title: '车系报表'
        },
      }
    ]
  },
  {
    path: '/detailed',
    component: Layout,
    meta: {
      title: '数据明细',
      icon: 'courseware'
    },
    hidden: false,
    children: [
      {
        path: 'custom',
        name: 'custom',
        hidden: false,
        component: () => import('@/views/detailed/custom'),
        meta: {
          title: '客户明细'
        },
      },
      {
        path: 'follow',
        name: 'follow',
        hidden: false,
        component: () => import('@/views/detailed/follow'),
        meta: {
          title: '跟进明细'
        },
      }
    ]
  },
  {
    path: '/customman',
    component: Layout,
    meta: {
      title: '客户管理',
      icon: 'upbeat'
    },
    hidden: false,
    children: [
      {
        path: 'lead',
        name: 'lead',
        hidden: false,
        component: () => import('@/views/customman/lead'),
        meta: {
          title: '线索客户',
          // icon: 'upbeat'
        },
      },
      {
        path: 'intention',
        name: 'intention',
        hidden: false,
        component: () => import('@/views/customman/intention'),
        meta: {
          title: '意向客户',
          // icon: 'upbeat'
        },
      },
      {
        path: 'order',
        name: 'order',
        hidden: false,
        component: () => import('@/views/customman/order'),
        meta: {
          title: '订车客户',
          // icon: 'upbeat'
        },
      },
      {
        path: 'deal',
        name: 'deal',
        hidden: false,
        component: () => import('@/views/customman/deal'),
        meta: {
          title: '交车客户',
          // icon: 'upbeat'
        },
      },
      {
        path: 'defeat',
        name: 'defeat',
        hidden: false,
        component: () => import('@/views/customman/defeat'),
        meta: {
          title: '战败客户',
          // icon: 'upbeat'
        },
      },
      {
        path: 'invalid',
        name: 'invalid',
        hidden: false,
        component: () => import('@/views/customman/invalid'),
        meta: {
          title: '无效客户',
          // icon: 'upbeat'
        },
      },
    ]
  },
  {
    path: '/group',
    component: Layout,
    meta: {
      title: '经销商管理',
      icon: 'delar'
    },
    hidden: false,
    children: [
      {
        path: 'person',
        name: 'person',
        hidden: false,
        component: () => import('@/views/group/person'),
        meta: {
          title: '人员管理',
          icon: 'delar'
        },
      }
    ]
  },
  {
    path: '/detail',
    component: Layout,
    meta: {
      title: '客户信息',
      icon: 'delar'
    },
    hidden: true,
    children: [
      {
        path: 'detail',
        name: 'detail',
        hidden: false,
        component: () => import('@/views/common/detail'),
        meta: {
          title: '客户信息',
          // icon: 'delar'
        },
      }
    ]
  },
  {
    path: '/examine',
    component: Layout,
    meta: {
      title: '待处理',
      icon: 'courseware'
    },
    hidden: false,
    children: [
      {
        path: 'defeat',
        name: 'defeat',
        hidden: false,
        component: () => import('@/views/examine/defeat'),
        meta: {
          title: '战败审批',
          // icon: 'courseware'
        },
      },
      {
        path: 'invalid',
        name: 'invalid',
        hidden: false,
        component: () => import('@/views/examine/invalid'),
        meta: {
          title: '无效审批',
          // icon: 'courseware'
        },
      },
      {
        path: 'task',
        name: 'task',
        hidden: false,
        component: () => import('@/views/examine/task'),
        meta: {
          title: '任务审批',
          // icon: 'courseware'
        },
      },
      {
        path: 'overdue',
        name: 'overdue',
        hidden: false,
        component: () => import('@/views/examine/overdue'),
        meta: {
          title: '逾期未跟进',
        },
      },
    ]

  },
  // 上传文件的路由地址
  {
    path: '/import',
    component: Layout,
    hidden: true, // 隐藏在左侧菜单中
    children: [{
      path: '',
      component: () => import('@/views/import')
    }]
  }
]

// 经销商 经理
export const dealerRoutes5 = [
  {
    path: '/basic',
    component: Layout,
    meta: {
      title: '基础设置',
      icon: 'system'
    },
    hidden: false,
    children: [
      {
        path: 'car',
        name: 'car',
        hidden: false,
        component: () => import('@/views/basic/car'),
        meta: {
          title: '车型管理',
        },
      },
      {
        path: 'source',
        name: 'source',
        hidden: false,
        component: () => import('@/views/basic/source'),
        meta: {
          title: '客户来源管理',
        },
      },
      {
        path: 'reason',
        name: 'reason',
        hidden: false,
        component: () => import('@/views/basic/reason'),
        meta: {
          title: '战败原因管理',
        },
      },
      {
        path: 'invalid',
        name: 'invalid',
        hidden: false,
        component: () => import('@/views/basic/invalid'),
        meta: {
          title: '无效原因管理',
        },
      },
      {
        path: 'intention',
        name: 'intention',
        hidden: false,
        component: () => import('@/views/basic/intention'),
        meta: {
          title: '意向等级管理',
        },
      },
      {
        path: 'event',
        name: 'event',
        hidden: false,
        component: () => import('@/views/basic/event'),
        meta: {
          title: '活动管理',
        },

      },
      {
        path: 'leadList',
        name: 'leadList',
        hidden: true,
        component: () => import('@/views/basic/leadList'),
        meta: {
          title: '活动留资列表',
        },
      }
    ]
  },
  {
    path: '',
    component: Layout,
    meta: {
      title: '数据报表',
      icon: 'kpi'
    },
    hidden: false,
    children: [
      {
        path: 'source',
        name: 'source',
        hidden: false,
        component: () => import('@/views/report/source'),
        meta: {
          title: '来源报表',
        },
      },
      {
        path: 'groupexcel',
        name: 'groupxcel',
        hidden: false,
        component: () => import('@/views/report/group'),
        meta: {
          title: '分店/小组报表',
        },
      },
      {
        path: 'sale',
        name: 'sale',
        hidden: false,
        component: () => import('@/views/report/sale'),
        meta: {
          title: '销售顾问报表',
        },
      },
      {
        path: 'serail',
        name: 'serail',
        hidden: false,
        component: () => import('@/views/report/serail'),
        meta: {
          title: '车系报表',
        },
      }
    ]
  },
  {
    path: '/detailed',
    component: Layout,
    meta: {
      title: '数据明细',
      icon: 'courseware'
    },
    hidden: false,
    children: [
      {
        path: 'custom',
        name: 'custom',
        hidden: false,
        component: () => import('@/views/detailed/custom'),
        meta: {
          title: '客户明细',
        },
      },
      {
        path: 'follow',
        name: 'follow',
        hidden: false,
        component: () => import('@/views/detailed/follow'),
        meta: {
          title: '跟进明细',
        },
      },
    ]
  },
  {
    path: '/customman',
    component: Layout,
    meta: {
      title: '客户管理',
      icon: 'upbeat'
    },
    hidden: false,
    children: [
      {
        path: 'lead',
        name: 'lead',
        hidden: false,
        component: () => import('@/views/customman/lead'),
        meta: {
          title: '线索客户',
        },
      },
      {
        path: 'intention',
        name: 'intention',
        hidden: false,
        component: () => import('@/views/customman/intention'),
        meta: {
          title: '意向客户',
        },
      },
      {
        path: 'order',
        name: 'order',
        hidden: false,
        component: () => import('@/views/customman/order'),
        meta: {
          title: '订车客户',
        },
      },
      {
        path: 'deal',
        name: 'deal',
        hidden: false,
        component: () => import('@/views/customman/deal'),
        meta: {
          title: '交车客户',
        },
      },
      {
        path: 'defeat',
        name: 'defeat',
        hidden: false,
        component: () => import('@/views/customman/defeat'),
        meta: {
          title: '战败客户',
        },
      },
      {
        path: 'invalid',
        name: 'invalid',
        hidden: false,
        component: () => import('@/views/customman/invalid'),
        meta: {
          title: '无效客户',
        },
      },
    ]
  },
  {
    path: '/detail',
    component: Layout,
    meta: {
      title: '客户信息',
      icon: 'delar'
    },
    hidden: true,
    children: [
      {
        path: 'detail',
        name: 'detail',
        hidden: false,
        component: () => import('@/views/common/detail'),
        meta: {
          title: '客户信息',
        },
      },
      {
        path: 'process',
        name: 'process',
        hidden: false,
        component: () => import('@/views/common/process'),
        meta: {
          title: '线索导入',
        },
      }
    ]
  },
  {
    path: '/examine',
    component: Layout,
    meta: {
      title: '待处理',
      icon: 'courseware'
    },
    hidden: false,
    children: [
      {
        path: 'defeat',
        name: 'defeat',
        hidden: false,
        component: () => import('@/views/examine/defeat'),
        meta: {
          title: '战败审批',
        },
      },
      {
        path: 'invalid',
        name: 'invalid',
        hidden: false,
        component: () => import('@/views/examine/invalid'),
        meta: {
          title: '无效审批',
        },
      },
      {
        path: 'task',
        name: 'task',
        hidden: false,
        component: () => import('@/views/examine/task'),
        meta: {
          title: '任务审批',
        },
      },
      {
        path: 'transfer',
        name: 'transfer',
        hidden: false,
        component: () => import('@/views/examine/transfer'),
        meta: {
          title: '异地流转审批',
        },
      },
      {
        path: 'callocation',
        name: 'callocation',
        hidden: false,
        component: () => import('@/views/examine/callocation'),
        meta: {
          title: '客户待分配',
        },
      },
      {
        path: 'allocation',
        name: 'allocation',
        hidden: false,
        component: () => import('@/views/examine/allocation'),
        meta: {
          title: '线索待分配',
        },
      },
      {
        path: 'overdue',
        name: 'overdue',
        hidden: false,
        component: () => import('@/views/examine/overdue'),
        meta: {
          title: '逾期未跟进',
        },
      },
    ]

  },
  {
    path: '/group',
    component: Layout,
    meta: {
      title: '经销商管理',
      icon: 'delar'
    },
    hidden: false,
    children: [
      {
        path: 'group',
        name: 'group',
        hidden: false,
        component: () => import('@/views/group/index'),
        meta: {
          title: '分店/小组管理',
        },
      },
      {
        path: 'person',
        name: 'person',
        hidden: false,
        component: () => import('@/views/group/person'),
        meta: {
          title: '人员管理',
        },
      }
    ]
  },
  {
    path: '/stock',
    component: Layout,
    meta: {
      title: '库存管理',
      icon: 'nested'
    },
    hidden: false,
    children: [
      {
        path: 'stock',
        name: 'stock',
        hidden: false,
        component: () => import('@/views/stock/index'),
        meta: {
          title: '库存管理',
          icon: 'nested'
        },
      }
    ]
  },
  {
    path: '/record',
    component: Layout,
    meta: {
      title: '操作记录',
      icon: 'eye'
    },
    hidden: false,
    children: [
      {
        path: 'rallocation',
        name: 'rallocation',
        hidden: false,
        component: () => import('@/views/record/allocation'),
        meta: {
          title: '分配记录'
        },
      },
      {
        path: 'rupload',
        name: 'rupload',
        hidden: false,
        component: () => import('@/views/record/upload'),
        meta: {
          title: '上传记录'
        },
      },
    ]
  },
  {
    path: '/weixin',
    component: Layout,
    meta: {
      title: '微信客户',
      icon: 'wework'
    },
    hidden: false,
    children: [
      {
        path: 'wxcust',
        name: 'wxcust',
        hidden: false,
        component: () => import('@/views/weixin/weixin'),
        meta: {
          title: '微信客户',
          icon: 'wework'
        },
      }
    ]
  },
  {
    path: '/target',
    component: Layout,
    meta: {
      title: '业绩目标管理',
      icon: 'total-week'
    },
    hidden: false,
    children: [
      {
        path: 'targetPerson',
        name: 'targetPerson',
        hidden: false,
        component: () => import('@/views/target/person'),
        meta: {
          title: '业绩目标',
          icon: 'total-week'
        },
      }
    ]
  },
  // 上传文件的路由地址
  {
    path: '/import',
    component: Layout,
    hidden: true, // 隐藏在左侧菜单中
    children: [{
      path: '',
      component: () => import('@/views/import')
    }]
  },
]

//经销商-销售顾问
export const counselorRouters2 = [
  {
    path: '',
    component: Layout,
    meta: {
      title: '数据报表',
      icon: 'kpi'
    },
    hidden: false,
    children: [
      {
        path: 'source',
        name: 'source',
        hidden: false,
        component: () => import('@/views/report/source'),
        meta: {
          title: '来源报表'
        },
      },
      {
        path: 'group',
        name: 'group',
        hidden: false,
        component: () => import('@/views/report/group'),
        meta: {
          title: '分店/小组报表'
        },
      },
      {
        path: 'sale',
        name: 'sale',
        hidden: false,
        component: () => import('@/views/report/sale'),
        meta: {
          title: '销售顾问报表'
        },
      },
      {
        path: 'serail',
        name: 'serail',
        hidden: false,
        component: () => import('@/views/report/serail'),
        meta: {
          title: '车系报表'
        },
      }
    ]
  },
  {
    path: '/detailed',
    component: Layout,
    meta: {
      title: '数据明细',
      icon: 'courseware'
    },
    hidden: false,
    children: [
      {
        path: 'custom',
        name: 'custom',
        hidden: false,
        component: () => import('@/views/detailed/custom'),
        meta: {
          title: '客户明细',
          // icon: 'courseware'
        },
      },
      {
        path: 'follow',
        name: 'follow',
        hidden: false,
        component: () => import('@/views/detailed/follow'),
        meta: {
          title: '跟进明细',
          // icon: 'courseware'
        },
      }
    ]
  },
  {
    path: '/customman',
    component: Layout,
    meta: {
      title: '客户管理',
      icon: 'upbeat'
    },
    hidden: false,
    children: [
      {
        path: 'lead',
        name: 'lead',
        hidden: false,
        component: () => import('@/views/customman/lead'),
        meta: {
          title: '线索客户',
          // icon: 'upbeat'
        },
      },
      {
        path: 'intention',
        name: 'intention',
        hidden: false,
        component: () => import('@/views/customman/intention'),
        meta: {
          title: '意向客户',
          // icon: 'upbeat'
        },
      },
      {
        path: 'order',
        name: 'order',
        hidden: false,
        component: () => import('@/views/customman/order'),
        meta: {
          title: '订车客户',
          // icon: 'upbeat'
        },
      },
      {
        path: 'deal',
        name: 'deal',
        hidden: false,
        component: () => import('@/views/customman/deal'),
        meta: {
          title: '交车客户',
          // icon: 'upbeat'
        },
      },
      {
        path: 'defeat',
        name: 'defeat',
        hidden: false,
        component: () => import('@/views/customman/defeat'),
        meta: {
          title: '战败客户',
          // icon: 'upbeat'
        },
      },
      {
        path: 'invalid',
        name: 'invalid',
        hidden: false,
        component: () => import('@/views/customman/invalid'),
        meta: {
          title: '无效客户',
          // icon: 'upbeat'
        },
      },
    ]
  },
  {
    path: '/detail',
    component: Layout,
    meta: {
      title: '客户信息',
      icon: 'delar'
    },
    hidden: true,
    children: [
      {
        path: 'detail',
        name: 'detail',
        hidden: false,
        component: () => import('@/views/common/detail'),
        meta: {
          title: '客户信息',
          // icon: 'delar'
        },
      }
    ]
  },
  {
    path: '/group',
    component: Layout,
    meta: {
      title: '经销商管理',
      icon: 'delar'
    },
    hidden: false,
    children: [
      // {
      //   path: 'group',
      //   name: 'group',
      //   hidden: false,
      //   component: () => import('@/views/group/index'),
      //   meta: {
      //     title: '分店管理/小组',
      //     icon: 'delar'
      //   },
      // },
      {
        path: 'person',
        name: 'person',
        hidden: false,
        component: () => import('@/views/group/person'),
        meta: {
          title: '人员管理',
          icon: 'delar'
        },
      }
    ]
  },
  // 上传文件的路由地址
  {
    path: '/import',
    component: Layout,
    hidden: true, // 隐藏在左侧菜单中
    children: [{
      path: '',
      component: () => import('@/views/import')
    }]
  }
]

export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({
    y: 0
  }),
  routes: constantRouterMap,
})



// WEBPACK FOOTER //
// ./src/router/index.js